import { Component } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';

@Component({
  selector: 'app-select-engineer-specialization-form',
  template: `
    <nz-cascader [nzOptions]="SPECIALIZATIONS"
                 [(ngModel)]="selectedSpecialization"
                 (nzSelectionChange)="selectSpecialization($event)"
                 [nzDisabled]="disabled"
                 class="w-100"></nz-cascader>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectEngineerSpecializationFormComponent
    }
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzCascaderModule
  ]
})
export class SelectEngineerSpecializationFormComponent implements ControlValueAccessor {

  SPECIALIZATIONS = [
    {
      value: '01',
      label: 'Проектная деятельность',
      children: [
        {
          value: '0101',
          label: 'Главный инженер проекта',
          isLeaf: true
        },
        {
          value: '0102',
          label: 'Главный архитектор проекта',
          isLeaf: true
        },
        {
          value: '0103',
          label: 'Главный конструктор',
          children: [
            {
              value: '010301',
              label: 'по несущим и ограждающим конструкциям',
              children: [
                {
                  value: '01030101',
                  label: 'гидротехник',
                  isLeaf: true
                },
                {
                  value: '01030102',
                  label: 'строительное проектирование',
                  isLeaf: true
                }
              ]
            },
            {
              value: '010302',
              label: 'по инженерным сетям и сооружениям',
              children: [
                {
                  value: '01030201',
                  label: 'теплогазоснабжение и вентиляция',
                  isLeaf: true
                },
                {
                  value: '01030202',
                  label:
                    'водоснабжение и канализация/водоснабжение и водоотведение',
                  isLeaf: true
                },
                {
                  value: '01030203',
                  label: 'инженер связи',
                  isLeaf: true
                },
                {
                  value: '01030204',
                  label: 'инженер-электрик',
                  isLeaf: true
                },
                {
                  value: '01030205',
                  label: 'инженер нефти и газа',
                  isLeaf: true
                }
              ]
            },
            {
              value: '010303',
              label: 'по транспортному строительству',
              children: [
                {
                  value: '01030301',
                  label: 'инженер автомобильных дорог и аэродромов',
                  isLeaf: true
                },
                {
                  value: '01030302',
                  label: 'инженер мостов и тоннелей',
                  isLeaf: true
                },
                {
                  value: '01030303',
                  label: 'инженер железнодорожных путей',
                  isLeaf: true
                }
              ]
            },
            {
              value: '010304',
              label: 'По технологическому оборудованию',
              isLeaf: true
            }
          ]
        },
        {
          value: '0104',
          label: 'Ведущий инженер проектировщик',
          children: [
            {
              value: '010401',
              label: 'по несущим и ограждающим конструкциям',
              children: [
                {
                  value: '01040101',
                  label: 'гидротехник',
                  isLeaf: true
                },
                {
                  value: '01040102',
                  label: 'строительное проектирование',
                  isLeaf: true
                }
              ]
            },
            {
              value: '010402',
              label: 'по инженерным сетям и сооружениям',
              children: [
                {
                  value: '01040201',
                  label: 'теплогазоснабжение и вентиляция',
                  isLeaf: true
                },
                {
                  value: '01040202',
                  label:
                    'водоснабжение и канализация/водоснабжение и водоотведение',
                  isLeaf: true
                },
                {
                  value: '01040203',
                  label: 'инженер связи',
                  isLeaf: true
                },
                {
                  value: '01040204',
                  label: 'инженер-электрик',
                  isLeaf: true
                },
                {
                  value: '01040205',
                  label: 'инженер нефти и газа',
                  isLeaf: true
                }
              ]
            },
            {
              value: '010403',
              label: 'по транспортному строительству',
              children: [
                {
                  value: '01040301',
                  label: 'инженер автомобильных дорог и аэродромов',
                  isLeaf: true
                },
                {
                  value: '01040302',
                  label: 'инженер мостов и тоннелей',
                  isLeaf: true
                },
                {
                  value: '01040303',
                  label: 'инженер железнодорожных путей',
                  isLeaf: true
                }
              ]
            },
            {
              value: '010404',
              label: 'По технологическому оборудованию',
              isLeaf: true
            },
            {
              value: '010405',
              label: 'По архитектуре',
              isLeaf: true
            }
          ]
        }
      ]
    },
    {
      value: '02',
      label: 'СМР',
      children: [
        {
          value: '0201',
          label: 'Главный инженер',
          isLeaf: true
        },
        {
          value: '0202',
          label: 'Начальник производственно-технического отдела',
          isLeaf: true
        },
        {
          value: '0203',
          label: 'Начальник участка',
          children: [
            {
              value: '020301',
              label: 'по несущим и ограждающим конструкциям',
              children: [
                {
                  value: '02030101',
                  label: 'гидротехник',
                  isLeaf: true
                },
                {
                  value: '02030102',
                  label: 'строительство',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020302',
              label: 'по инженерным сетям и сооружениям',
              children: [
                {
                  value: '02030201',
                  label: 'теплогазоснабжение и вентиляция',
                  isLeaf: true
                },
                {
                  value: '02030202',
                  label:
                    'водоснабжение и канализация/водоснабжение и водоотведение',
                  isLeaf: true
                },
                {
                  value: '02030203',
                  label: 'инженер связи',
                  isLeaf: true
                },
                {
                  value: '02030204',
                  label: 'инженер-электрик',
                  isLeaf: true
                },
                {
                  value: '02030205',
                  label: 'инженер нефти и газа',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020303',
              label: 'по транспортному строительству',
              children: [
                {
                  value: '02030301',
                  label: 'инженер автомобильных дорог и аэродромов',
                  isLeaf: true
                },
                {
                  value: '02030302',
                  label: 'инженер мостов и тоннелей',
                  isLeaf: true
                },
                {
                  value: '02030303',
                  label: 'инженер железнодорожных путей',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020304',
              label: 'По технологическому оборудованию',
              isLeaf: true
            }
          ]
        },
        {
          value: '0204',
          label: 'Производитель работ',
          children: [
            {
              value: '020401',
              label: 'по несущим и ограждающим конструкциям',
              children: [
                {
                  value: '02040101',
                  label: 'гидротехник',
                  isLeaf: true
                },
                {
                  value: '02040102',
                  label: 'строительство',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020402',
              label: 'по инженерным сетям и сооружениям',
              children: [
                {
                  value: '02040201',
                  label: 'теплогазоснабжение и вентиляция',
                  isLeaf: true
                },
                {
                  value: '02040202',
                  label:
                    'водоснабжение и канализация/водоснабжение и водоотведение',
                  isLeaf: true
                },
                {
                  value: '02040203',
                  label: 'инженер связи',
                  isLeaf: true
                },
                {
                  value: '02040204',
                  label: 'инженер-электрик',
                  isLeaf: true
                },
                {
                  value: '02040205',
                  label: 'инженер нефти и газа',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020403',
              label: 'по транспортному строительству',
              children: [
                {
                  value: '02040301',
                  label: 'инженер автомобильных дорог и аэродромов',
                  isLeaf: true
                },
                {
                  value: '02040302',
                  label: 'инженер мостов и тоннелей',
                  isLeaf: true
                },
                {
                  value: '02040303',
                  label: 'инженер железнодорожных путей',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020404',
              label: 'По технологическому оборудованию',
              isLeaf: true
            }
          ]
        },
        {
          value: '0205',
          label: 'Мастер',
          children: [
            {
              value: '020501',
              label: 'по несущим и ограждающим конструкциям',
              children: [
                {
                  value: '02050101',
                  label: 'гидротехник',
                  isLeaf: true
                },
                {
                  value: '02050102',
                  label: 'строительство',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020502',
              label: 'по инженерным сетям и сооружениям',
              children: [
                {
                  value: '02050201',
                  label: 'теплогазоснабжение и вентиляция',
                  isLeaf: true
                },
                {
                  value: '02050202',
                  label:
                    'водоснабжение и канализация/водоснабжение и водоотведение',
                  isLeaf: true
                },
                {
                  value: '02050203',
                  label: 'инженер связи',
                  isLeaf: true
                },
                {
                  value: '02050204',
                  label: 'инженер-электрик',
                  isLeaf: true
                },
                {
                  value: '02050205',
                  label: 'инженер нефти и газа',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020503',
              label: 'по транспортному строительству',
              children: [
                {
                  value: '02050301',
                  label: 'инженер автомобильных дорог и аэродромов',
                  isLeaf: true
                },
                {
                  value: '02050302',
                  label: 'инженер мостов и тоннелей',
                  isLeaf: true
                },
                {
                  value: '02050303',
                  label: 'инженер железнодорожных путей',
                  isLeaf: true
                }
              ]
            },
            {
              value: '020504',
              label: 'По технологическому оборудованию',
              isLeaf: true
            }
          ]
        }
      ]
    }
  ];

  selectedSpecialization: any;

  touched = false;
  disabled = false;

  onChange = (specialization: any) => {
    console.log(specialization);
    this.selectedSpecialization = specialization;
  };

  onTouched = () => {
    console.log('SelectEngineerSpecializationFormComponent > onTouched');
  };

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  writeValue(specialization: any): void {
    console.log(specialization);
    if (specialization && specialization.code && specialization.code.startsWith('ENGINEER')) {
      const specializationCode = specialization.code.toString().replace('ENGINEER_', '');
      const returnValue = [];
      for (let i = 0; i <= specializationCode.length; i++) {
        if (i === 2) {
          returnValue.push(specializationCode.substring(0, i));
        }
        if (i === 4) {
          returnValue.push(specializationCode.substring(0, i));
        }
        if (i === 6) {
          returnValue.push(specializationCode.substring(0, i));
        }
        if (i === 8) {
          returnValue.push(specializationCode.substring(0, i));
        }
        if (i === 10) {
          returnValue.push(specializationCode.substring(0, i));
        }
      }
      this.onChange(returnValue);
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  selectSpecialization(specializationPath: any) {
    console.log(specializationPath);
    const leafValue = specializationPath[specializationPath.length - 1];
    let fullName = specializationPath[0].label;
    for (let i = 1; i < specializationPath.length; i++) {
      if (i === 1) {
        fullName += ': ';
      } else {
        fullName += ' - ';
      }
      fullName += specializationPath[i].label;
    }
    const selectedSpecialization = {
      code: 'ENGINEER_' + leafValue.value,
      name: fullName
    };
    this.onChange(selectedSpecialization);
  }
}
